import React from 'react'
import PropTypes from 'prop-types'
import { CardActions } from '@mui/material'
import CancelButton from 'components/buttons/CancelButton'
import SaveButton from 'components/buttons/SaveButton'

const EventsAccordionActions = ({ onCancel, onSave, isLoading, hasPendingChanges }) => {
  if (!hasPendingChanges) {
    return null
  }

  return (
    <CardActions p={2} sx={{ justifyContent: 'space-between', px: 2, py: 2 }}>
      <CancelButton disabled={isLoading} onClick={onCancel} />
      <SaveButton loading={isLoading} disabled={isLoading} size="small" onClick={onSave} />
    </CardActions>
  )
}

EventsAccordionActions.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  hasPendingChanges: PropTypes.bool,
}

export default EventsAccordionActions
